/**
 * Normalize Next.js router `query.id` (or any case id input) into a usable string.
 * Rejects undefined, empty values, and the literal "undefined" that can appear
 * in URLs/query casting and produce `/audit/undefined/...` requests.
 */
export const getValidCaseId = (
	id: string | string[] | undefined | null
): string | undefined => {
	if (typeof id === 'string') {
		const trimmed = id.trim();
		if (trimmed && trimmed !== 'undefined') return trimmed;
		return undefined;
	}

	if (Array.isArray(id) && typeof id[0] === 'string') {
		return getValidCaseId(id[0]);
	}

	return undefined;
};
